module.exports = __webpack_public_path__ + "assets/2472906ba7de2a27dbaa09392aceeb98.jpg";